// pages/Clients/imagemodal.jsx
import React from 'react';
import { ImageOff } from 'lucide-react';

const ImageModal = ({
  isOpen,
  onClose,
  imageData,
  imageLoading,
  imageNotFound,
  currentLog
}) => {

  const getResultColor = (result) => {
    if (result === 'PASS') return '#16a34a';
    if (result === 'FAIL') return '#dc2626';
    return '#2563eb';
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '700px',
          background: 'var(--bg-secondary)',
          borderRadius: '18px',
          overflow: 'hidden',
          boxShadow: '0 25px 60px rgba(0,0,0,0.35)',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid var(--border-light)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'var(--bg-secondary)'
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: '20px',
                fontWeight: 600,
                color: 'var(--text-primary)'
              }}
            >
              Event Image
            </h3>

            {currentLog && (
              <div
                style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary)',
                  marginTop: '4px'
                }}
              >
               Time: {currentLog.time}
              </div>
            )}
          </div>

          <button
            onClick={onClose}
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '50%',
              border: 'none',
              background: 'var(--bg-primary)',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: '20px',
            overflowY: 'auto'
          }}
        >
          {imageLoading ? (
            <div
              style={{
                textAlign: 'center',
                padding: '60px 20px'
              }}
            >
              <p>Loading image...</p>
            </div>
          ) : imageNotFound ? (
            <div
              style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: 'var(--text-secondary)'
              }}
            >
              <ImageOff size={72} strokeWidth={1.2} style={{ marginBottom: '12px' }} />

              <p>Image not available for this event</p>
            </div>
          ) : (
            <>
              {/* Image */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <img
                  src={imageData}
                  alt="Event"
                  style={{
                    width: '100%',
                    maxHeight: '39vh',
                    objectFit: 'contain',
                    borderRadius: '12px',
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border-light)'
                  }}
                />
              </div>

              {/* Details */}
              {currentLog && (
                <div
                  style={{
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border-light)',
                    borderRadius: '12px',
                    padding: '16px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '10px 0',
                      borderBottom: '1px solid var(--border-light)'
                    }}
                  >
                    <span style={{ color: 'var(--text-secondary)' }}>BAC</span>
                    <strong>{currentLog.bac || 'N/A'}</strong>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '10px 0',
                      borderBottom: '1px solid var(--border-light)'
                    }}
                  >
                    <span style={{ color: 'var(--text-secondary)' }}>Result</span>
                    <strong
                      style={{
                        color: getResultColor(currentLog.result)
                      }}
                    >
                      {currentLog.result || 'INFO'}
                    </strong>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
